import { useSortable } from '@dnd-kit/sortable'
import { Box, Button, Paper, Typography, useMediaQuery } from '@mui/material'
import { UserInfo } from 'Components/_common/Collaborators/UserInfo'
import { useContext } from 'react'
import { When } from 'react-if'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'
import { BREAKPOINT_MIN_MD } from 'Theme/stylesUtil'

import { useChangeJudgeRoundMutation, useDeleteJudgeMutation } from '../../../../Queries/Contests'
import { NotificationContext } from '../../../Notification/context'
import { JudgeCardInputs } from './JudgeCardInputs'
import { JudgesRoundSelector } from './JudgeProfileComponents/JudgesRoundSelector'

export const JudgeCard = ({
  roundNames,
  judge,
  onClick,
  isSelected,
  isModal,
  sortId,
  action,
  setValue,
  index,
  watch,
  contestId,
  ownerId,
}) => {
  const { mutate: saveJudgeRound } = useChangeJudgeRoundMutation(contestId, judge.user_id)
  const { mutate: deleteJudge } = useDeleteJudgeMutation(contestId)
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: sortId })
  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)
  const { notification } = useContext(NotificationContext)

  const handleChangeRounds = (rounds) => {
    saveJudgeRound(
      { rounds },
      {
        onSuccess: () => {
          notification.success(`You have successfully changed round for ${judge.login}`)
        },
      },
    )
  }
  const handleDeleteJudge = (judgeId) => {
    deleteJudge(
      { contestId, judgeId },
      {
        onSuccess: () => {
          notification.success(`You have successfully removed ${judge.login} from contest`)
        },
      },
    )
  }
  const handleInput = (e) => setValue(`judges[${index}].role`, e.target.value)
  const handleSelect = (value) => setValue(`judges[${index}].rounds`, value)

  return (
    <Paper
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        borderLeft: `3px solid ${isSelected ? theme.palette.secondary.main : 'transparent'}`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2),
        background: isModal || !isSelected ? theme.palette.background.pale : theme.palette.background.paper,
        boxShadow: 'none',
      })}
      onClick={() => onClick(judge.id)}
      ref={setNodeRef}
      style={{
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition,
      }}
    >
      <UserInfo
        info={judge.role || 'Judge’s title'}
        userImages={judge.user_images}
        login={judge.login}
        sx={(theme) => ({
          [theme.breakpoints.down('lg')]: {
            width: isBiggerThanMDScreen ? '90px' : 'initial',
            flexDirection: isBiggerThanMDScreen ? 'column' : 'row',
          },
        })}
      />

      <Box
        display="flex"
        sx={(theme) => ({
          gap: theme.spacing(2),

          [theme.breakpoints.down('lg')]: {
            gap: isBiggerThanMDScreen ? 0 : theme.spacing(2),
          },
        })}
      >
        {action === 'create' && (
          <JudgeCardInputs
            roundNames={roundNames}
            handleInput={handleInput}
            handleSelect={handleSelect}
            index={index}
          />
        )}
        <When condition={isModal}>
          <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <When condition={judge.state === 'invited'}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Typography
                  variant="body2bold"
                  color="text.tertiary"
                >
                  Invited
                </Typography>
                <FAIcon
                  iconClassName={FA_ICONS.LOADER}
                  color="text.tertiary"
                />
              </Box>
            </When>

            <JudgesRoundSelector
              roundNames={roundNames}
              judge={judge}
              onSelect={handleChangeRounds}
              handleDeleteJudge={handleDeleteJudge}
              ownerId={ownerId}
            />
          </Box>
        </When>
        <Button
          sx={{
            background: 'transparent',
            '&:hover': {
              background: 'transparent',
            },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '40px',
            borderRadius: '6px',
            width: '50px',
            minWidth: 'unset',
            fontSize: '16px',
            cursor: 'pointer',
          }}
          onClick={(e) => e.stopPropagation()}
          {...attributes}
          {...listeners}
        >
          <FAIcon
            iconClassName={FA_ICONS.EQUALS}
            color={'text.secondary'}
            iconFontSize={16}
          />
        </Button>
      </Box>
    </Paper>
  )
}
